import { Head } from "@inertiajs/react"
import { Tag } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"

type TagRow = {
  id: number
  name: string
  taggings_count: number
}

export default function AdminTagsIndex({ tags }: { tags: TagRow[] }) {
  return (
    <>
      <Head title="Tags">
        <meta name="description" content="Browse tags in the admin area." />
        <meta property="og:title" content="Tags" />
        <meta property="og:description" content="Browse tags in the admin area." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <h1>Tags</h1>
          <p className="mt-1">
            {tags.length} {tags.length === 1 ? "tag" : "tags"} in the database.
          </p>
        </div>

        <ul className="mt-6 divide-y divide-hairline overflow-hidden rounded-md border border-hairline bg-page">
          {tags.map((tag) => (
            <li key={tag.id} className="flex items-center gap-3 px-4 py-3">
              <Tag className="h-4 w-4 shrink-0 text-ink-muted" />
              <div className="min-w-0 flex-1">
                <span className="text-sm font-medium text-ink-display">{tag.name}</span>
              </div>
              <span className="text-xs text-ink-muted">
                {tag.taggings_count} {tag.taggings_count === 1 ? "use" : "uses"}
              </span>
            </li>
          ))}
        </ul>
      </AdminShell>
    </>
  )
}
